var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "row row-wrap"
  }, [_c('a', {
    staticClass: "col-xs-12 aItem row sideless",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "id": _vm.item.sid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.item_clicked(_vm.item)
      }
    }
  }, [_c('div', {
    staticClass: "icon-text-container",
    class: {
      'active-tree-item': (_vm.item.sid == _vm.$root.active_tree_item.id && (_vm.$route.query.p == _vm.item.idp || _vm.$route.query.p == null))
    }
  }, [_c('span', {
    staticStyle: {
      "padding": "0px"
    }
  }, [(!_vm.isFirstSon) ? _c('div', {
    staticClass: "sideless side-branch",
    class: {
      'last': _vm.ind == _vm.$parent.leaves.length - 1
    }
  }, [_c('div', {
    staticClass: "branch top"
  }), _vm._v(" "), _c('div', {
    staticClass: "branch bot"
  })]) : _vm._e(), _vm._v(" "), _c('i', {
    class: _vm.icons.file
  })]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "custom_spinner",
    staticStyle: {
      "margin": "0px -3px 0px 3px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hide-collapse"
  }, [(_vm.configs.showId) ? _c('span', [_vm._v(_vm._s(_vm.item.sid + " - "))]) : _vm._e(), _vm._v(_vm._s(_vm.item.des))])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04bc4c26","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/recursive-list-document.vue
// module id = 1361
// module chunks = 1